import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css'
import './i18n'
import store from './store/Store';
import { Provider } from "react-redux";

// Register service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/dashboard/firebase-messaging-sw.js', { scope: '/dashboard/' })
    .then(registration => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
